var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "am-margin-bottom-sm cart",
      attrs: { headerStyle: { background: "#d4d5d5" }, "dis-hover": "" }
    },
    [
      _c(
        "h2",
        {
          staticClass: "am-g-collapse am-cf",
          attrs: { slot: "title" },
          slot: "title"
        },
        [
          _c("div", { staticClass: "am-fl" }, [_vm._v("购物车")]),
          _c("div", { staticClass: "am-fr am-text-right am-u-sm-5" }, [
            _c("div", { staticClass: "am-u-sm-12" }, [
              _c("span", [_vm._v(_vm._s(_vm.store.storeName))]),
              _c("span", { staticClass: "am-padding-horizontal-xs" }, [
                _vm._v("|")
              ]),
              _vm.orderType === 2
                ? _c("span", [_vm._v(_vm._s(_vm.store.waitTime) + "分钟")])
                : _c("span", [_vm._v(_vm._s(_vm.store.waitTime) + "分钟")])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "am-u-sm-12 am-text-truncate am-font-w-n am-padding-top-xs",
                attrs: { title: _vm._f("strTime")(_vm.store.businessTimes) }
              },
              [
                _vm._v(
                  "\n          (" +
                    _vm._s(_vm._f("strTime")(_vm.store.businessTimes)) +
                    ")\n        "
                )
              ]
            )
          ])
        ]
      ),
      _c("div"),
      _c(
        "div",
        { staticClass: "cart-content" },
        [
          _c(
            "div",
            {
              staticClass:
                "cart-title-bar am-margin-bottom-xs am-g-collapse am-g"
            },
            [
              _c("div", { staticClass: "am-u-md-4" }, [_vm._v("餐品")]),
              _c("div", { staticClass: "am-u-md-3" }, [_vm._v("数量x单价")]),
              _c("div", { staticClass: "am-u-md-2" }, [_vm._v("总价")]),
              _c("div", { staticClass: "am-u-md-3" }, [_vm._v("操作")])
            ]
          ),
          [
            _c("div", { staticClass: "cart-product-list am-g-collapse am-g" }, [
              _c(
                "ul",
                { staticClass: "am-g-collapse am-g" },
                _vm._l(_vm.products, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: item._key + index,
                      staticClass: "am-u-sm-12 am-margin-bottom-xs"
                    },
                    [
                      _c("div", { staticClass: "am-u-md-4" }, [
                        _c(
                          "div",
                          {
                            staticClass: "am-text-truncate",
                            attrs: { title: item.name }
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]),
                      _c("div", { staticClass: "am-u-md-3" }, [
                        _c("div", { staticClass: "am-fl" }, [
                          _c(
                            "div",
                            { staticClass: "am-fl" },
                            [
                              item.readonly
                                ? [
                                    _c("input", {
                                      staticClass: "am-input am-input-small",
                                      staticStyle: { width: "50px" },
                                      attrs: {
                                        autocomplete: "off",
                                        spellcheck: "false",
                                        type: "text",
                                        placeholder: "",
                                        readonly: ""
                                      },
                                      domProps: { value: item.num }
                                    })
                                  ]
                                : [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.num,
                                          expression: "item.num"
                                        }
                                      ],
                                      staticClass: "am-input am-input-small",
                                      staticStyle: { width: "50px" },
                                      attrs: {
                                        autocomplete: "off",
                                        spellcheck: "false",
                                        type: "text",
                                        placeholder: "",
                                        maxlength: 20
                                      },
                                      domProps: { value: item.num },
                                      on: {
                                        blur: function($event) {
                                          return _vm.changeProductDynamicMax(
                                            item
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "num",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "am-fl",
                              staticStyle: { "padding-left": "5px" }
                            },
                            [
                              _c("span", [_vm._v("x")]),
                              _c("span", { staticClass: "prefix-price-unit" }, [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(
                                      _vm._f("computePrice")(
                                        item.pricing || item.price
                                      )
                                    )
                                )
                              ])
                            ]
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "am-u-md-2" }, [
                        _c(
                          "span",
                          { staticClass: "prefix-price-unit am-color-price" },
                          [
                            _vm._v(
                              _vm._s(_vm.currency) +
                                _vm._s(
                                  _vm._f("computePrice")(item.totalProductPrice)
                                )
                            )
                          ]
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "am-u-md-3 am-g-collapse cart-product-action"
                        },
                        [
                          !item.readonly
                            ? _c("div", { staticClass: "am-u-sm-4 am-fr" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeProduct(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  删除\n                "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "am-u-sm-4 am-fr" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    return _vm.switchRemark(item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  备注\n                "
                                )
                              ]
                            )
                          ]),
                          !item.readonly
                            ? _c("div", { staticClass: "am-u-sm-4 am-fr" }, [
                                item.isChange
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showProduct(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  修改\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      ),
                      item._remarkVisible
                        ? _c("div", { staticClass: "am-u-md-12" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "cart-product-remark am-padding-xs am-cf"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "am-u-md-9" },
                                  [
                                    _c("Input", {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        placeholder: "请输入餐品备注",
                                        clearable: ""
                                      },
                                      model: {
                                        value: item._remark,
                                        callback: function($$v) {
                                          _vm.$set(item, "_remark", $$v)
                                        },
                                        expression: "item._remark"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              ),
              _c(
                "ul",
                { staticClass: "am-g-collapse am-g" },
                [
                  _vm._l(_vm.promotionsList, function(item, key) {
                    return _c(
                      "li",
                      {
                        key: key,
                        staticClass: "am-u-sm-12 am-margin-bottom-xs"
                      },
                      [
                        _c("div", { staticClass: "am-u-md-4" }, [
                          _vm._v(_vm._s(item.content))
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.num,
                                expression: "item.num"
                              }
                            ],
                            staticClass: "am-u-md-2 am-u-end"
                          },
                          [_vm._v(_vm._s(item.num) + "份")]
                        )
                      ]
                    )
                  }),
                  _vm.preDeliveryPrice !== 0
                    ? _c(
                        "li",
                        { staticClass: "am-u-sm-12 am-margin-bottom-xs" },
                        [
                          _c("span", [_vm._v("减免配送费：")]),
                          _c(
                            "span",
                            { staticClass: "prefix-price-unit am-color-price" },
                            [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  _vm._s(_vm.preDeliveryPrice)
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "cart-total am-padding-vertical-xs am-g-collapse am-g",
                staticStyle: { "font-weight": "bold" }
              },
              [
                _c("div", { staticClass: "am-u-md-4 am-text-center" }, [
                  _vm._v("小计")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "am-u-md-3 am-text-truncate",
                    attrs: { title: _vm.numTotal + "份" }
                  },
                  [_vm._v(_vm._s(_vm.numTotal) + "份")]
                ),
                _c("div", { staticClass: "am-u-md-2 am-u-end" }, [
                  _vm._v(_vm._s(_vm._f("computePrice")(_vm.cart.fee.products)))
                ])
              ]
            )
          ],
          _c("div", { staticClass: "cart-other-price" }, [
            _c("p", [
              _c("span", [_vm._v("配送费：")]),
              _c("span", { staticClass: "prefix-price-unit am-color-price" }, [
                _vm._v(
                  _vm._s(_vm.currency) +
                    _vm._s(_vm._f("computePrice")(_vm.delivery))
                )
              ])
            ]),
            _c("p", [
              _c("span", [_vm._v("餐盒费：")]),
              _c("span", { staticClass: "prefix-price-unit am-color-price" }, [
                _vm._v(
                  _vm._s(_vm.currency) +
                    _vm._s(_vm._f("computePrice")(_vm.cart.fee.mealFee))
                )
              ])
            ]),
            _vm.isOrderClaim
              ? _c("div", { staticClass: "cart-order-claim" }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("未达起送条件：")]),
                      _vm.store.deliveryType === 2
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "prefix-price-unit am-color-price"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(
                                      _vm._f("formatPrice")(_vm.store.reachFee)
                                    ) +
                                    "起送"
                                )
                              ]
                            )
                          ]
                        : [
                            _c(
                              "span",
                              {
                                staticClass: "prefix-price-unit am-color-price"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(
                                      _vm._f("formatPrice")(_vm.store.reachPart)
                                    ) +
                                    "份起送"
                                )
                              ]
                            )
                          ]
                    ],
                    2
                  )
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "cart-price-count am-padding-top-xs" }, [
            _c("span", [_vm._v("合计：")]),
            _c("span", { staticClass: "prefix-price-unit am-color-price" }, [
              _vm._v(
                _vm._s(_vm.currency) + _vm._s(_vm._f("formatPrice")(_vm.total))
              )
            ]),
            _c("span", [_vm._v("(不含优惠)")])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bf47190", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf47190","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/order/Cart/Cart.vue
// module id = 24S5
// module chunks = 0